import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __ANPR_PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

interface CourtTypeListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (courtType?: string) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
  id?: string;
}

type Key = {
  codice: string;
};

interface CourtType {
  key: Key;
  descrizione: string;
}

const CourtTypeListComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  label = 'Tipo tribunale',
  id = 'courtType',
}: CourtTypeListComponentProps): React.ReactElement => {
  const [courtType] = useHttpFetch<HttpResponseList<CourtType>, Array<ItemVM>>(
    `${__ANPR_PERSON_API_URL__}/tipo-tribunale`,
    {
      onBootstrap: true,
      initialData: [],
      transformer: (response: AxiosResponse<HttpResponseList<CourtType>>) => {
        const { data } = response;

        return data?.payload.list.map((item) => ({
          id: item.key.codice,
          value: item.descrizione,
        })) as Array<ItemVM>;
      },
    }
  );

  const list = courtType.data as Array<ItemVM>;

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list?.map((item: ItemVM) => (
          <MenuItem key={item?.id} value={item?.id}>
            {item?.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CourtTypeListComponent.displayName = 'Court Type List component';

const CourtTypeList = memo(CourtTypeListComponent);

export default CourtTypeList as typeof CourtTypeListComponent;
